






























































































































import { Component, Vue, Prop, PropSync, Inject } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { User } from '@/api/users';
import { AdminFeatureFlags } from '@/api/utils';

@Component
export default class NavBar extends Vue {
  @PropSync('show', { type: Boolean }) public sync!: boolean;
  @Prop(Function) public logout!: (o?: any) => void;
  @Inject() public readonly flags!: AdminFeatureFlags;
  @Getter('auth/user') public readonly self!: User | null;

  public get isCrew(): boolean {
    if (!this.self) { return false; }
    const roles: string[] | undefined = this.self['https://interface.ticketmgmt.dev/role'];
    return roles?.findIndex((r) => r === 'Crew') !== -1;
  }

  public get isAdmin(): boolean {
    if (!this.self) { return false; }
    const roles: string[] | undefined = this.self['https://interface.ticketmgmt.dev/role'];
    return roles?.findIndex((r) => r === 'admin') !== -1;
  }
}
